// URL Routes - Page controller
// 

JLM.routes = (function() {
	
	// Variables: Private _______________________________________________________
	
	// Settings
	let is_resizing = false,
		timeout_resize;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Settings
		JLM.mobile = /mobile|android|kindle|silk|midp|phone|(windows .+arm|touch)/.test( navigator.userAgent.toLowerCase() );
		JLM.retina = ( window.devicePixelRatio > 1 );
		
		// 404 page
		if ( $('#jl_page').attr('data-template') === '404' ) {
			setupNavigation();
			setupPageDefault();
		}
		// All other pages
		else {
			const url_parts = window.location.pathname.toLowerCase().substr(1).split('/');
			let form_contact;
			
			switch ( url_parts[0] ) {
				case '':
					const page_home = new JLM.MD.PageHome( $('#jl_page') );
					setupNavigation();
					setupPageDefault();
					break;
				case 'actors':
				case 'youth-actors':
				case 'brand-ambassadors':
				case 'content-creators':
				case 'mcs-entertainers':
				case 'presenters':
				case 'voice-actors':
					let page_landing = new JLM.MD.PageLanding( $('#jl_page') );
					setupNavigation();
					setupPageDefault();
					break;
				case 'our-actors':
				case 'our-youth-actors':
				case 'our-voices':
				case 'our-voice-actors':
				case 'our-content-creators':
				case 'our-brand-ambassadors':
				case 'our-presenters':
				case 'our-mcs-entertainers':
				case 'our-writers-directors':
					setupNavigation();
					let division_type = url_parts[0].match(/^our-(.*)/i)[1];
					if ( division_type == 'youth-actors' ) {
						division_type = 'actors';
					}
					if ( division_type == 'voice-actors' ) {
						division_type = 'voices';
					}
					if ( url_parts.length > 1 ) {
						setupProfile( division_type );
					} else {
						setupDirectory( division_type );
					}
					break;
				case 'player':
					setupMediaPlayer();
					break;
				case 'about':
					let page_about = new JLM.MD.PageAbout( $('#jl_page') );
					setupNavigation();
					setupPageDefault();
					break;
				case 'contact':
					let page_contact = new JLM.MD.PageContact( $('#jl_page') );
					setupNavigation();
					setupPageDefault();
					break;
				case 'contact':
					form_contact = new JLM.MD.FormContact( $('#jl_contact') );
					setupNavigation();
					setupPageDefault();
					break;
				case 'subscribe':
					let page_subscribe = new JLM.MD.PageSubscribe( $('#jl_page') );
					setupNavigation();
					setupPageDefault();
					break;
				default:
					setupNavigation();
					setupPageDefault();
					break;
			}
		}
		
		// Common events
		$(window).on('resize', onResize);
		
		// Setup
		$('html').removeClass('noanimate');
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Event: Window resizing
	// 
	function onResize() {
		if ( !is_resizing ) {
			$('html').addClass('noanimate');
			is_resizing = true;
		}
		if ( timeout_resize ) clearTimeout( timeout_resize );
		timeout_resize = setTimeout(function() {
			$('html').removeClass('noanimate');
			is_resizing = false;
			timeout_resize = null;
		}, 250);
	}
	
	
	// Navigation
	// 
	function setupNavigation() {
		JLM.menu = new JLM.MD.Menu( $('#jl_navigation') );
	}
	
	
	// Talent Directory
	// 
	function setupDirectory( division_type ) {
		// References
		JLM.directory = new JLM.MD.Directory( $('#jl_page'), division_type );
		
		// Events
		JLM.menu.on('open', function() {
			JLM.directory.expand();
		});
		JLM.menu.on('close', function() {
			JLM.directory.contract();
		});
		JLM.menu.on('shortlist_remove', function() {
			JLM.directory.removeFromShortlist.apply( this, arguments );
		});
		JLM.menu.on('shortlist_empty', function() {
			JLM.directory.emptyShortlist();
		});
		JLM.directory.on('shortlist_add', function() {
			JLM.menu.addToShortlist.apply( this, arguments );
		});
		JLM.directory.on('shortlist_remove', function() {
			JLM.menu.removeFromShortlist.apply( this, arguments );
		});
	}
	
	
	// Talent Profile
	// 
	function setupProfile( division_type ) {
		// References
		JLM.profile = new JLM.MD.TalentProfile( $('#jl_page'), division_type );
		
		// Events
		JLM.menu.on('open', function() {
			JLM.profile.expand();
		});
		JLM.menu.on('close', function() {
			JLM.profile.contract();
		});
		JLM.menu.on('shortlist_remove shortlist_empty', function() {
			JLM.profile.removeFromShortlist();
		});
		JLM.profile.on('shortlist_add', function() {
			JLM.menu.addToShortlist.apply( this, arguments );
		});
		JLM.profile.on('shortlist_remove', function() {
			JLM.menu.removeFromShortlist.apply( this, arguments );
		});
	}
	
	
	// Other pages
	// 
	function setupPageDefault() {
		const page = $('#jl_page');
		
		// Events
		JLM.menu.on('open', function() {
			page.addClass('expand');
		});
		JLM.menu.on('close', function() {
			page.removeClass('expand');
		});
	}
	
	
	// Media Player (Video & Audio)
	// 
	function setupMediaPlayer() {
		let ref_player = $('#media-player');
		if ( ref_player.hasClass('video') ) {
			JLM.player = new JLM.MD.MediaPlayerVideo( ref_player );
		} else {
			JLM.player = new JLM.MD.MediaPlayerAudio( ref_player );
		}
	}
	
	
	
	// Setup ____________________________________________________________________
	
	Raven.context(function () {
    	$(init);
	});
	
})();